// extracted by mini-css-extract-plugin
export default {"days":"SelecTimeArea_days__s5Nba","day":"SelecTimeArea_day__agBHo","selectedTime":"SelecTimeArea_selectedTime__KjP-t"};